import React, { useEffect, useState } from "react";
import Avatar from "../atomic/Avatar";
import clsx from "clsx";
import "cropperjs/dist/cropper.css";
import { useRef } from "react";
import { boy, girl, other } from "lib/common/const/avatarLocation";
import { useAppSelector } from "redux/hooks";
import { getUser } from "redux/reducers/userSlice";
import { imgUrl, resolveImgUrl } from "utils/constants";

interface ChooseAvatarProps extends React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  children?: React.ReactElement<any>;
  relative?: boolean;
  showDefaultAvatar?: boolean;
}

function ChooseAvatar({
  className,
  children,
  relative = true,
  onChange,
  showDefaultAvatar = true,
}: ChooseAvatarProps) {
  // For the showing the choose avatar dropdown
  const [choose, setChoose] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [currentAvatar, setCurrentAvatar] = useState("/avatar/other_4.svg");
  const [userAvatar, setUserAvatar] = useState("other_4.svg");
  const user = useAppSelector(getUser);

  useEffect(() => {
    if (onChange) {
      onChange({ target: { value: userAvatar } } as any);
    }
  }, [userAvatar, onChange]);

  // this handles the avatar choose dropdown
  const chooseAvatar = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    let target = e.target as Element;

    setCurrentAvatar(`/avatar/${target.id}.svg`);
    setUserAvatar(target.id + ".svg");
    setChoose(false);
  };

  const setAvatar = (val: any) => {
    setCurrentAvatar(val);
  };

  return (
    <div
      className={`flex items-center ${relative && relative} justify-between`}
    >
      {showDefaultAvatar ? (
        <>
          <div>
            <input
              className="hidden"
              ref={inputRef}
              value={userAvatar}
              onInput={(e) =>
                onChange &&
                onChange(e as unknown as React.ChangeEvent<HTMLDivElement>)
              }
            />

            <Avatar
              className="avatar"
              displayDropdown
              image={currentAvatar}
              dropdownOnClick={() => setChoose(!choose)}
              onChange={() => { }} // To do
            />

            {choose && (
              <div
                className={clsx(
                  { "w-1/2": !className?.includes("w-") },
                  `absolute left-0   p-5 shadow rounded-lg mt-2 z-50 bg-white transition-opacity ease-in-out w-full duration-300 `,
                  className,
                )}
              >
                <h5 className="text-gray-700">Choose Avatar</h5>

                <div className="boy border-b-2 pt-4 pb-5">
                  <p className="text-gray-500 mb-2 font-medium ">Male</p>
                  <div className="flex flex-wrap">
                    {boy.map((boy) => (
                      <Avatar
                        onClick={chooseAvatar}
                        imageId={boy}
                        className="cursor-pointer hover:bg-gray-100"
                        key={boy}
                        image={`/avatar/${boy}.svg`}
                      />
                    ))}
                  </div>
                </div>
                <div className="girl border-b-2 pt-4 pb-5">
                  <p className="text-gray-500 font-medium mb-2">Female</p>
                  <div className="flex flex-wrap">
                    {girl.map((girl) => (
                      <Avatar
                        onClick={chooseAvatar}
                        className="cursor-pointer hover:bg-gray-100"
                        key={girl}
                        imageId={girl}
                        image={`/avatar/${girl}.svg`}
                      />
                    ))}
                  </div>
                </div>
                <div className="other  pt-4 pb-5">
                  <p className="text-gray-500 font-medium mb-2">Other</p>
                  <div className="flex flex-wrap">
                    {other.map((other) => (
                      <Avatar
                        onClick={chooseAvatar}
                        className="cursor-pointer hover:bg-gray-100"
                        key={other}
                        imageId={other}
                        image={`/avatar/${other}.svg`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <span
            className="text-gray-500 font-semibold cursor-pointer mx-4"
            onClick={() => {
              setCurrentAvatar("");
            }}
          >
            Reset
          </span>
        </>
      ) : (
        <Avatar
          image={
            user?.userProfilePicture
              ? resolveImgUrl(user?.userProfilePicture)
              : user?.userAvatarPicture
                ? `/avatar/${user?.userAvatarPicture}`
                : "/img/logo/App_Icon_Primary.png"
          }
        />
      )}

      {children &&
        React.cloneElement(children, {
          setAvatar: setAvatar,
          showDefaultAvatar: showDefaultAvatar,
        })}
    </div>
  );
}

export default ChooseAvatar;
